import { render } from "./InputIcon.vue?vue&type=template&id=a5b8fa6c"
import script from "./InputIcon.vue?vue&type=script&lang=js"
export * from "./InputIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__